import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { Profile } from '@/models/profile';
import { STORAGE_KEYS } from '@/services/storageKeys';

interface UserState {
  /**
   * Identifier for package lookup.
   * Verified phone number (E.164) for package lookup.
   */
  phoneNumber: string;
  profile: Profile | null;
  setPhoneNumber: (phoneNumber: string) => void;
  setProfile: (profile: Profile) => void;
  clearProfile: () => void;
  reset: () => void;
}

const initialState: Pick<UserState, 'phoneNumber' | 'profile'> = {
  phoneNumber: '',
  profile: null,
};

export const useUserStore = create<UserState>()(
  persist<UserState>(
    (set) => ({
      ...initialState,

      setPhoneNumber: (phoneNumber: string) => {
        set({ phoneNumber });
      },

      setProfile: (profile: Profile) => {
        set({ profile });
      },

      clearProfile: () => {
        set({ profile: null });
      },

      reset: () => {
        set({ ...initialState });
      },
    }),
    {
      name: STORAGE_KEYS.USER_STORE,
    },
  ),
);
